// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Returns the items `control` selects: sp-select items, nested ones included, or `{ title, dataset }` per option. */
export function selectedItems(control) {
  if (!control) {
    return [];
  }

  if (control.tagName === "SP-SELECT") {
    const values = [].concat(control.value ?? []).map(String);

    function selectedChildren(items) {
      return items.flatMap((item) => {
        const selected = values.includes(String(item.value)) ? [item] : [];

        return selected.concat(selectedChildren(item.children || []));
      });
    }

    return selectedChildren(control.items || []);
  }

  return Array.from(control.selectedOptions || []).map((option) => ({
    title: option.text,
    dataset: option.dataset,
  }));
}

/** Returns the title of the first item `control` selects, or an empty string. */
export function selectedItemTitle(control) {
  return selectedItems(control)[0]?.title || "";
}

/** Returns the `key` data value of the first item `control` selects. */
export function selectedItemData(control, key) {
  return selectedItems(control)[0]?.dataset?.[key];
}

/** Returns whether the first item `control` selects is marked directional. */
export function isDirectionalSelection(control) {
  return [true, "true", ""].includes(selectedItemData(control, "directional"));
}

/** Returns whether the select filter `select` holds a value. */
export function isSelectFilterActive(select) {
  if (select?.localName === "select" && select.multiple) {
    return select.selectedOptions.length > 0;
  }

  return !!select?.value?.length;
}

/** Clears the select filter `select` to `defaultValue`; a multiple select is emptied. */
export function clearSelectFilter(select, defaultValue) {
  // A native select takes one string as its value, so a multiple one is cleared option by option.
  if (select.localName === "select" && select.multiple) {
    Array.from(select.options).forEach((option) => {
      option.selected = false;
    });
  } else {
    select.value = select.multiple ? [] : defaultValue;
  }
}

/** Returns the titles of the items the select filter `select` selects, joined for its applied-filter label. */
export function selectFilterDescription(select) {
  return selectedItems(select)
    .map((item) => item.title)
    .join(", ");
}

/** Announces a cleared filter through a bubbling `change` that carries `data` as its detail. */
export function announceFilterChange(control, data) {
  control.dispatchEvent(
    new CustomEvent("change", {
      bubbles: true,
      detail: data,
    }),
  );
}
